<!--
 * @Author:
 * @Description: 上传文件组件
-->
<template>
  <div v-loading="uploadLoading">
    <el-upload
      class="upload-demo"
      action=""
      :auto-upload="false"
      :on-remove="handleRemove"
      :file-list="fileList"
      :on-change="changeFile"
      :multiple="multiple"
      drag
    >
      <i class="el-icon-upload text-67px blue-700 text-color-system !mt-70px"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </el-upload>
    <div class="pt-20px text-center">
      <el-button @click="deleteAll" size="small">清空</el-button>
      <el-button
        type="primary"
        @click="uploadConfirm"
        size="small"
        :loading="uploadLoading"
        :disabled="uploadLoading"
        >确认上传</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'uploadFiles',
  props: {
    initFiles: {
      type: Array,
      default() {
        return []
      },
    },
    uploadLoading: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fileList: [],
      currentFiles: [],
      accept: ['zip'],
    }
  },
  watch: {
    initFiles: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val && val.length > 0) {
          this.fileList = val.map((i) => {
            return {
              name: i.file,
              documentFileId: i.documentFileId,
              status: 'success',
            }
          })
        } else {
          this.fileList = []
        }
      },
    },
  },
  methods: {
    handleRemove(file, fileList) {
      this.$emit('removeFile', file)
      this.fileList = fileList
    },
    changeFile(file, fileList) {
      this.fileList = fileList
      this.currentFiles = fileList.filter((item) => {
        return item.status !== 'success'
      })
      // const name = file.name
      // const fileSuffix = name.substring(name.lastIndexOf('.') + 1).toLowerCase()
      // if (
      //   !this.accept
      //     .map((i) => {
      //       return i.toLowerCase()
      //     })
      //     .includes(fileSuffix) &&
      //   this.type === 1
      // ) {
      //   this.$message.warning(`上传文件只能是${this.accept.join('、')}`)
      //   this.fileList = []
      //   return false
      // }
      // return true
    },
    deleteAll() {
      this.fileList = []
    },
    uploadConfirm() {
      this.$emit('uploadConfirm', this.currentFiles)
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
